"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumericInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_jss_1 = __importDefault(require("react-jss"));
const classnames_1 = __importDefault(require("classnames"));
const autonumeric_1 = __importDefault(require("autonumeric"));
const numeral_1 = __importDefault(require("numeral"));
const numericInput_style_1 = __importDefault(require("./numericInput.style"));
class NumericInput extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.inputRef = react_1.default.createRef();
        this.state = {
            value: this.props.value
        };
        this.handleChange = (event) => {
            const temp = numeral_1.default(event.target.value).value();
            const value = temp === null ? undefined : temp;
            this.setState({ value });
            this.props.onChange(value);
        };
        this.isNegative = () => this.state.value < 0;
    }
    componentDidMount() {
        this.inputRef.current.value = String(this.state.value);
        new autonumeric_1.default(this.inputRef.current);
    }
    render() {
        const { classes, ...otherProps } = this.props;
        return (jsx_runtime_1.jsx("input", Object.assign({ ref: this.inputRef, 
            // onChange={this.handleChange}
            className: classnames_1.default(classes.numericInput, this.isNegative() && classes.negative) }, otherProps), void 0));
    }
}
exports.NumericInput = NumericInput;
exports.default = react_jss_1.default(numericInput_style_1.default)(NumericInput);
//# sourceMappingURL=index.js.map